export class Utilidades {
  public static focus(elemento: HTMLElement) {
    if (!elemento || !(elemento instanceof HTMLElement))
        return;
    
    elemento.focus();
  }
}
